import { ChangeDetectorRef, Component, OnInit, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ChartFile } from '../models/index';
import { Api, Session } from '../services/index';
import { UploadOutput, UploadInput, UploadFile, humanizeBytes, UploaderOptions, UploadStatus } from 'ngx-uploader';
import { Environment } from '../app.environment';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-exam-files',
  styleUrls: ['exam-upload-file.css'],
  templateUrl: './exam-upload-file.html'
})

export class ExamUploadFile implements OnInit {
  filesToUpload: Array<File> = [];
  fileTypes = "application/pdf image/png image/jpeg image/gif";
  intakeFileList: ChartFile[] = [];
  patientId: number;
  formData: FormData;
  files: UploadFile[];
  uploadedIntakeFiles: Array<UploadFile>;
  uploadInput: EventEmitter<UploadInput>;
  humanizeBytes: Function;
  dragOver: boolean;
  options: UploaderOptions;
  buttonText = "Skip";
  isUploading = false;


  constructor(private api: Api,
    private route: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    private session: Session,
    private translateService: TranslateService,
    public env: Environment) {
    this.patientId = this.route.snapshot.params['patientId'] || '';
    this.options = { concurrency: 1 };
    this.files = [];
    this.uploadInput = new EventEmitter<UploadInput>();
    this.humanizeBytes = humanizeBytes;
    this.uploadedIntakeFiles = new Array<UploadFile>();

    this.translateService.get('EXAM_UPLOAD_FILE.BUTTON_SKIP').subscribe((res: string) => {
      if (res) {
        this.buttonText = res;
      } else {
        this.buttonText = 'Skip';
      }

      console.log(res);
    });


  }



  onUploadOutput(output: UploadOutput): void {
    if (output.type === 'allAddedToQueue') {
      const event: UploadInput = {
        type: 'uploadAll',
        url: this.env.settings.apiUrl,
        method: 'POST',
        data: { foo: 'bar' }
      };
      this.uploadInput.emit(event);
    } else if (output.type === 'addedToQueue' && typeof output.file !== 'undefined') {
      this.files.push(output.file);
      this.filesToUpload.push(output.file.nativeFile);
      this.uploadFile(output.file.nativeFile);
    } else if (output.type === 'uploading' && typeof output.file !== 'undefined') {
      const index = this.files.findIndex(file => typeof output.file !== 'undefined' && file.id === output.file.id);
      this.files[index] = output.file;
    } else if (output.type === 'removed') {
      this.files = this.files.filter((file: UploadFile) => file !== output.file);
    } else if (output.type === 'dragOver') {
      this.dragOver = true;
    } else if (output.type === 'dragOut') {
      this.dragOver = false;
    } else if (output.type === 'drop') {
      this.dragOver = false;
    } else if (output.type === 'rejected' && typeof output.file !== 'undefined') {
      console.log(output.file.name + ' rejected');
    }
    this.translateService.get('EXAM_UPLOAD_FILE.BUTTON_CONTINUE').subscribe((res: string) => {
      if (res) {
        this.buttonText = res;
      } else {
        this.buttonText = 'Continue';
      }

      console.log(res);
    });

    
    this.files = this.files.filter(file => file.progress.status !== UploadStatus.Done);
  }

  cancelUpload(id: string): void {
    this.uploadInput.emit({ type: 'cancel', id: id });
  }

  removeAllFiles(): void {
    this.uploadInput.emit({ type: 'removeAll' });
  }

  ngOnInit() {
    this.getIntakeFiles();
  }

  getIntakeLOB() {
    return this.session.intakeLob;
  }

  getIntakeFiles() {
    let _getIntakeFile = this.api.getIntakeFile(this.session.serverIntake.intakeId);
    _getIntakeFile.subscribe(response => {
      this.intakeFileList = response;
      if (!this.changeDetectorRef['destroyed']) {
        this.changeDetectorRef.detectChanges();
      }
      this.session.uploadFiles = this.intakeFileList;
    })
  }

  clickSelect() {
    $("#uploadFileInput").click();
  }

  trim(value) {
    return value.trim();
  }

  noFiles() {
    this.router.navigate(['exam-review-request/' + this.patientId]);
  }


  fileChangeEvent(fileInput: any) {
    if (this.fileTypes.indexOf(fileInput.target.files[0].type) >= 0) {
      this.isUploading = true;
      this.filesToUpload = <Array<File>>fileInput.target.files;

      console.log('**********************************************this.filesToUpload:', this.filesToUpload);

      this.uploadFiles();
    } else {
      $("#uploadFileInput").val('');
      alert('Only file types of PDF, JPG, JPEG, PNG, and GIF are allowed to be uploaded');
    }
  }

  //this duplicates files when selecting multiple files to upload because the event fires for each selected file
  //which adds the file to the filesToUpload. The filesToUpload gets uploaded again for each event.
  //
  uploadFiles() {

    if (this.filesToUpload.length === 0) {
      console.log('No files to upload..');
      return;
    }

    for (let i = 0; i < this.filesToUpload.length; i++) {
      this.api.uploadIntakeFiles(this.session.serverIntake.intakeId, [this.filesToUpload[i]]).subscribe(result => {
        if (i == this.filesToUpload.length - 1) {
          this.getIntakeFiles();
          this.filesToUpload = [];
          this.isUploading = false;
        }

      }, ex => {
        this.isUploading = false;
      });
    }

  }

  uploadFile(fileToUpload: File) {

    if (!fileToUpload) {
      console.log('No file to upload..');
      return;
    }
    this.api.uploadIntakeFiles(this.session.serverIntake.intakeId, [fileToUpload]).subscribe(result => {
      this.getIntakeFiles();
      this.filesToUpload = [];
      this.isUploading = false;
    }, ex => {
      this.isUploading = false;
    });


  }

  removeFile(file) {
    this.api.removeIntakeFile(this.session.serverIntake.intakeId, file).subscribe(result => {
      this.getIntakeFiles();
    }, ex => {
      this.filesToUpload = [];
    });
  }

  disableContinue() {
    return this.isUploading;
  }
}
